import { useCallback } from 'react';
import { downloadPdfFile } from '../../services/api/wr-tools/downloadPdfFile';

export const useEditorDownloadFile = (text: string) => {
  const handleDownloadPdfFile = useCallback(
    () => downloadPdfFile('solution.pdf', text),
    [text]
  );

  return {
    handleDownloadPdfFile,
  };
};
